<template>
  <div class="home-brick-box home-brick-row-2-box xm-plain-box">
    <Top />
    <Bottom />
    <div class="home-banner-box">
      <a href="https://www.mi.com/buy?product_id=12982">
        <img src="../../../assets/imgs/jiadian-banner.png" alt="test" width="1226" height="120">
      </a>
    </div>
  </div>
</template>

<script>
import Top from './Top'
import Bottom from './Bottom'

export default {
  name: 'Shouji',
  components:{
    Top,
    Bottom
  }
}
</script>

<style>
.home-brick-box {
  margin-bottom: 8px;
}
.home-flashsale {
  margin-bottom: 22px;
  position: relative;
}
.home-banner-box {
  /* height: 120px; */
  margin: 22px 0;
  overflow: hidden;
}
</style>